import { useEffect, useState } from "react";
import { Application } from "../../_Bootstrap/Application";

export type DarkModeListener = () => void;

/**
 * Check if we're currently in dark mode
 */
export function isDarkMode(): boolean {
    return Application.get("DarkModeManager").isDarkMode();
}

/**
 * Hook to respond to dark mode changes
 */
export function useDarkMode(): boolean {
    const [ darkMode, setDarkMode ] = useState(isDarkMode());

    useEffect(() => {
        const manager = Application.get("DarkModeManager");

        /**
         * Listener to register for dark mode changes
         */
        const listener = () => {
            setDarkMode(manager.isDarkMode());
        };

        manager.addListener(listener);

        return () => {
            manager.removeListener(listener);
        };
    }, []);

    return darkMode;
}
